import { useEffect, useState } from 'react';
import userLocalStorage from '../services/userLocalStorage';

const useGetUserLocalStorage = (
  storageKey: string,
  userId: number
): { data: Record<string, unknown> | undefined; hasRetrieved: boolean } => {
  const [hasRetrieved, setHasRetrieved] = useState(false);
  const [storedData, setStoredData] = useState();

  useEffect(() => {
    let isCancelled = false;
    const getStoredData = async () => {
      const localStorageData = await userLocalStorage.getItem(storageKey, userId);

      if (!isCancelled) {
        setStoredData(localStorageData);
        setHasRetrieved(true);
      }
    };

    getStoredData();

    return () => {
      isCancelled = true;
    };
  }, [storageKey, userId]);

  return { hasRetrieved, data: storedData };
};

export default useGetUserLocalStorage;
